import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import Button from "../../../../../common/Button";

const KeypadShowButton = ( props ) => {

  const { t } = useTranslation();

  return <Button className={ clsx( 'btn', 'btn-inputAnswer', props.className ) } onClick={ props.onShow }>{ t( 'LC_05_20.msg010' ) }</Button>;

};

export default KeypadShowButton;
